const getXpathCleared = (xpath) => xpath.replace("/@href", "");

const normalizeXpath = (xpath) => {
    const nawXpath = getXpathCleared(xpath);

    return nawXpath.replaceAll(/\[[\d]+\]/g, "[*]");
};

const merge = (xpath1, xpath2) => {
    if (normalizeXpath(xpath1) !== normalizeXpath(xpath2)) {
        return "";
    } else if (xpath1 === xpath2) {
        return "";
    } else {
        const xPath1 = xpath1.split("/");
        const xPath2 = xpath2.split("/");

        return xPath1
            .map((item, index) => {
                if(xPath1[index] === xPath2[index]){
                    return item;
                } else {
                    return `${item.split("[")[0]}[*]`;
                }
            })
            .join("/");
    }
};

const collapseXpath = (arr) => {
    const result = [];

    for (let i = 0; i < arr.length; i++) {
        let xpath1 = arr[i];
        let xpathAfterMerge = xpath1.selector;

        for (let j = 0; j < arr.length; j++) {
            let xpath2 = arr[j];

            let merged = merge(xpath1.selector, xpath2.selector);

            if (merged !== "") {
                xpathAfterMerge = merged;
            }
        }

        result.push(xpathAfterMerge);
    }

    const clearData = new Set(result);

    return [ ...clearData ].map((item) => ({
        selector: item,
        sub_selector: ""
    }));
};

export default collapseXpath;
